import { Link } from 'react-router-dom';
import type { Video } from '@/types/content';
import { formatPlays, getCategory } from '@/lib/videos';

interface VideoCardProps {
  video: Video;
  className?: string;
}

export default function VideoCard({ video, className = '' }: VideoCardProps) {
  const category = getCategory(video.category);

  return (
    <Link
      to={`/detail/${video.id}`}
      data-product-shop
      className={`group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-50 transition-colors hover:border-primary-300 ${className}`}
    >
      <div className="relative aspect-video w-full overflow-hidden bg-background-200">
        <img
          src={video.cover}
          alt={video.title}
          title={`${video.title} - 男同视频`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
        />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/60 to-transparent" />
        <span className="absolute left-2 top-2 flex items-center gap-1 rounded-md bg-black/45 px-2 py-0.5 text-xs font-medium text-white backdrop-blur-sm">
          <i className="ri-play-circle-fill text-accent-400" />
          {video.duration}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-accent-500 px-2 py-0.5 text-xs font-bold text-background-50">
          <i className="ri-star-fill text-[10px]" />
          {video.rating.toFixed(1)}
        </span>
        <span className="absolute bottom-2 left-2 flex items-center gap-1 text-xs font-medium text-white/90">
          <i className="ri-fire-line text-accent-300" />
          {formatPlays(video.plays)}次播放
        </span>
      </div>
      <div className="flex flex-1 flex-col gap-2 p-3 md:p-4">
        <h3 className="line-clamp-1 text-sm font-bold text-foreground-900 transition-colors group-hover:text-primary-600 md:text-base">
          {video.title}
        </h3>
        <p className="line-clamp-2 text-xs leading-relaxed text-foreground-500 md:text-sm">
          {video.description}
        </p>
        <div className="mt-auto flex flex-wrap items-center gap-2 pt-1 text-xs text-foreground-500">
          <span className="rounded bg-secondary-100 px-2 py-0.5 font-medium text-secondary-800">
            {category?.name}
          </span>
          <span>{video.year}</span>
          <span className="text-foreground-300">·</span>
          <span>{video.uploadDate}</span>
        </div>
      </div>
    </Link>
  );
}